import $ from 'jquery';
import 'jquery-sticky';
import 'jquery-smooth-scroll';

import 'bootstrap';
import "./sass/style.scss";
import feather from 'feather-icons';

$(document).ready(function() {
    $('.hero video').trigger('play');
    $('.main-navigation').sticky({ topSpacing: 0 });
    $('.admin-bar .main-navigation').unstick().sticky({ topSpacing: 32 });

    $('a:not([data-scroll-ignore])').smoothScroll({ offset: -80 });
    $('.admin-bar a:not([data-scroll-ignore])').smoothScroll("options", { offset: -112 });

    $('.carousel').each(function(index) { $(this).find('.carousel-item').carouselHeights() });


    $('[data-toggle="offcanvas"]').on('click', function() {
        $('.offcanvas-collapse').toggleClass('open');
        $('.offcanvas-collapse.open a').on('click', function() {
            $('.offcanvas-collapse').removeClass('open');
        });
    });

    /* Wordpress */
    /*Unwrap contactform 7 checkbox label*/
    $('.custom-control.custom-checkbox .wpcf7-form-control .custom-control-label').unwrap();

    /* Start Scroll animations */
    $('.animate').each(isScrolledIntoView);
    $(document).on("scroll", function() {
        $('.animate').each(isScrolledIntoView);

    });

});


window.addEventListener('load', function() {
    feather.replace();
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }
            form.classList.add('was-validated');
        }, false);
    });
}, false);



// Normalize Carousel Heights - pass in Bootstrap Carousel items.
$.fn.carouselHeights = function() {

    var items = $(this), //grab all slides
        heights = [], //create empty array to store height values
        tallest; //create variable to make note of the tallest slide

    var normalizeHeights = function() {

        items.each(function() { //add heights to array
            heights.push($(this).height());
        });
        tallest = Math.max.apply(null, heights); //cache largest value
        items.each(function() {
            $(this).css('min-height', tallest + 'px');
        });
    };

    normalizeHeights();

    $(window).on('resize orientationchange', function() {
        //reset vars
        tallest = 0;
        heights.length = 0;

        items.each(function() {
            $(this).css('min-height', '0'); //reset min-height
        });
        normalizeHeights(); //run it again 
    });

};

function isScrolledIntoView() {
    var $window = $(window);
    var $elem = $(this);
    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();
    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();
    if ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) {
        $elem.addClass("animation");
    } else $elem.removeClass("animation");
}